namespace Areas.ChangeManagement.Summary {
    "use strict";
    let changeManagementType: string;
    let changeManagementProfileId: number;
    let runQuery: boolean = false;

    let currentDetailGridRow: any;
    let detailAccountId: number;


    export function goToActions(projectInfoId: string) {
        return (e: any) => {
            if (e.value == 1) {
                Areas.ChangeManagement.Summary.goToTransmittals(e);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 2) {
                Areas.ChangeManagement.Summary.goToSharePoint(e);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 3) {
                Areas.ChangeManagement.Summary.goToPIFPAF(projectInfoId);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 4) {
                Areas.ChangeManagement.Summary.goToReportChangeOrder(e);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 5) {
                Areas.ChangeManagement.Summary.goToReportRFIAll(e);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 6) {
                Areas.ChangeManagement.Summary.goToReportRFI(e);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 7) {
                Areas.ChangeManagement.Summary.goToReportPendingRequests(e);
                clearSelectBoxSelection(e);
                return;
            }
            if (e.value == 8) {
                Areas.ChangeManagement.Summary.goToReportTransaction(e);
                clearSelectBoxSelection(e);
                return;
            }
        }
    }


    export function goToTransmittals(e: any) {
        const grid = $("#ChangeManagementSummaryGrid").dxDataGrid("instance");
        const row = grid.getSelectedRowsData();

        if (row.length == 1) {
            var id = 0;
            if (isNotEmpty(row[0].accountId)) {
                id = row[0].accountId;
            }
            else {
                return;
            }

            let linkInfo = "/Transmittal/Profile/View/" + id;
            location.href = linkInfo;
        }
    }

    export function goToSharePoint(e: any) {
        const grid = $("#ChangeManagementProfilesGrid").dxDataGrid("instance");
        var sharePointLink = grid.option("sharePointLink") as string;

        if (isNotEmpty(sharePointLink)) {
            Areas.websiteSharePoint(sharePointLink);
        }
        return
    }

    export function goToPIFPAF(projectInfoId) {
        let linkInfo = "https://projectinitiation.capnet.ucla.edu/Requests/View/Index/" + projectInfoId + "";
        window.open(linkInfo);
    }


    export function goToReportChangeOrder(e: any) {
        const grid = $("#ChangeManagementSummaryGrid").dxDataGrid("instance");
        const rows = grid.getSelectedRowsData();
        if (rows.length == 1) {
            clearSelectBoxSelection(e);
            var id = rows[0].changeManagementProfileId;
            const url = `/Reports/Report/GetReport840/${id}`;
            window.open(url);
        }
    }

    export function goToReportRFIAll(e: any) {
        const grid = $("#ChangeManagementSummaryGrid").dxDataGrid("instance");
        const rows = grid.getSelectedRowsData();
        if (rows.length == 1) {
            clearSelectBoxSelection(e);
            var id = rows[0].changeManagementProfileId;
            const url = `/Reports/Report/GetReport842/${id}`;
            window.open(url);
        }
    }

    export function goToReportRFI(e: any) {
        const grid = $("#ChangeManagementSummaryGrid").dxDataGrid("instance");
        const rows = grid.getSelectedRowsData();
        if (rows.length == 1) {
            clearSelectBoxSelection(e);
            var id = rows[0].changeManagementProfileId;
            const url = `/Reports/Report/GetReport843/${id}`;
            window.open(url);
        }
    }

    export function goToReportPendingRequests(e: any) {
        const grid = $("#ChangeManagementSummaryGrid").dxDataGrid("instance");
        const rows = grid.getSelectedRowsData();
        if (rows.length == 1) {
            clearSelectBoxSelection(e);
            var id = rows[0].changeManagementProfileId;
            const url = `/Reports/Report/GetReport841/${id}`;
            window.open(url);
        }
    }

    export function goToReportTransaction(e: any) {
        const grid = $("#SummaryDetailGrid").dxDataGrid("instance");
        const rows = grid.getSelectedRowsData();
        if (rows.length == 1) {
            clearSelectBoxSelection(e);
            var id = rows[0].changeManagementId;
            const url = `/Reports/Report/GetReport844/${id}`;
            window.open(url);
        }
    }

    export function getChangeManagementProfileId() {
        return changeManagementProfileId;
    }

    export function getChangementManagementType() {
        return changeManagementType;
    }

    export function canExecuteQuery() {
        return runQuery;
    }

    export function onSummaryGridSelectionChanged(e: any) {
        const selectedRows = e.component.getSelectedRowsData();

        if (selectedRows.length === 1) {
            runQuery = true;
            changeManagementProfileId = selectedRows[0].changeManagementProfileId;
            changeManagementType = selectedRows[0].changeManagementType;
            Areas.refreshGrid("SummaryDetailGrid");
        }
    }

    export function onSummaryContentReady(e: any) {
        if (!e.component.getSelectedRowKeys().length)
            e.component.selectRowsByIndexes(0);


    }

    export function detailGridSelectionChanged(e: any) {
        const dataGrid = e.component as DevExpress.ui.dxDataGrid;
        let dataId = dataGrid.getSelectedRowKeys()[0];
        let fileDesc = dataGrid.getSelectedRowsData()[0].changeManagementTitle;
        Areas.Attachment.updateAttachmentControls(dataId, "CM", fileDesc);

    }
    
    export function newChangeManagement(e: any) {
        const changeManagement = e.data;
        //setting this here because if there is no summary record, changemanagementprofileid does not get as 
        //summary events do not fire
        changeManagementProfileId = e.component.option("ChangeManagementProfileId");

        changeManagement.changeManagementProfileId = changeManagementProfileId;
        changeManagement.changeManagementTypeLk = changeManagementType;
        detailAccountId = e.component.option("AccountId");
    }

    export function addGridButtons(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        const disabled = !grid.option("IsEditable");

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: "escalation" },
            text: "Escalation",
            hint: "Create Escalation record",
            type: "default",
            icon: "add",
            disabled: disabled,
            onClick: escalate
        }, "before");

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: "escalation" },
            text: "Transmittal",
            hint: "Create Transmittal record",
            type: "default",
            icon: "add",
            disabled: disabled,
            onClick: transmittal
        }, "before");

    }



    export function escalate() {
        const dataGrid = $("#SummaryDetailGrid").dxDataGrid("instance");
        const selectedRows = dataGrid.getSelectedRowsData();

        if (selectedRows.length) {
            const dialog = new Dialogs.CreateChangeManagementEscalationDialog(escalateDialogClosing, selectedRows);
        }

    }

    export function transmittal() {
        const dataGrid = $("#SummaryDetailGrid").dxDataGrid("instance");
        const selectedRows = dataGrid.getSelectedRowsData();
        const parameters = {
            projectName: dataGrid.option("ProjectName"),
            projectNumber: dataGrid.option("ProjectNumber"),
            accountId: dataGrid.option("AccountId"),
            referenceTable: "ChangeManagement",
            data: selectedRows
        };

        if (selectedRows.length) {
            const dialog = new Dialogs.Transmittal.CreateTransmittalDialog((r, d) => { }, parameters);
        }
    }

    export function refreshSummaryGrid(e: any) {
        Areas.refreshGrid("ChangeManagementSummaryGrid");
    }

    function escalateDialogClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        Areas.refreshGrid("SummaryDetailGrid");
        Areas.refreshGrid("ChangeManagementSummaryGrid");
    }


    export function editDetailGridContactTemplate(cellElement, cellInfo) {
        let contactIdDisplay = !cellInfo.data.toContactId ? "Select..." : cellInfo.data.toContactId;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${contactIdDisplay}</div><div class="dx-lookup-arrow" id="contact-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectDetailGridContact);
        cellElement.append(html);
    }

    export function editDetailGridFromContactTemplate(cellElement, cellInfo) {
        let contactIdDisplay = !cellInfo.data.fromContactId ? "Select..." : cellInfo.data.fromContactId;
        let htmlString = `<div class="dx-texteditor dx-lookup-empty dx-widget dx-textbox dx-dropdowneditor dx-lookup dx-lookup-popover-mode"><input type="hidden" value=""><div class="dx-lookup-field-wrapper"><div class="dx-lookup-field" tabindex="0" role="combobox" aria-expanded="false">${contactIdDisplay}</div><div class="dx-lookup-arrow" id="contact-popup-button"></div></div></div>`;
        let html = $.parseHTML(htmlString);

        cellElement.on("click", selectDetailGridFromContact);
        cellElement.append(html);
    }

    export function selectDetailGridContact() {
        const parameters = { accountId: detailAccountId };
        const accountTeamContactLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(
                dialogAccountTeamContactClosing, parameters);

    }

    export function selectDetailGridFromContact() {
        const parameters = { accountId: detailAccountId };
        const accountTeamContactLookupDialog =
            new Areas.Dialogs.AccountTeam.AccountTeamContactLookupDialog(
                dialogAccountTeamFromContactClosing, parameters);

    }

    function dialogAccountTeamContactClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#SummaryDetailGrid").dxDataGrid("instance");

        var rowIndex = getDetailGridRowIndex(dataGrid);
        updateDetailContactGridRow(dataGrid, rowIndex, data);
    }

    function dialogAccountTeamFromContactClosing(dialogResult: DialogResult, data: any) {
        if (dialogResult === DialogResult.Cancel) return;

        const dataGrid = $("#SummaryDetailGrid").dxDataGrid("instance");

        var rowIndex = getDetailGridRowIndex(dataGrid);
        updateDetailFromContactGridRow(dataGrid, rowIndex, data);
    }

    function getDetailGridRowIndex(dataGrid: DevExpress.ui.dxDataGrid): number {
        let rowIndex = 0;

        if (currentDetailGridRow === undefined || currentDetailGridRow === null) {
            return rowIndex;
        } else if (currentDetailGridRow.changeManagementId) {
            rowIndex = dataGrid.getRowIndexByKey(currentDetailGridRow.changeManagementId);
        }

        return rowIndex;
    }

    function updateDetailContactGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "toContactId", data.contactId);
        dataGrid.cellValue(rowIndex, "toContactName", data.displayName);
        dataGrid.cellValue(rowIndex, "toCompany", data.companyName);

        currentDetailGridRow.toContactId = data.contactId;
        currentDetailGridRow.toContactName = data.displayName;
        currentDetailGridRow.toCompany = data.companyName;

        dataGrid.repaintRows([rowIndex]);
    }

    function updateDetailFromContactGridRow(dataGrid: DevExpress.ui.dxDataGrid, rowIndex: number, data: any) {

        dataGrid.cellValue(rowIndex, "fromContactId", data.contactId);
        dataGrid.cellValue(rowIndex, "fromContactName", data.displayName);
        dataGrid.cellValue(rowIndex, "fromCompany", data.companyName);

        currentDetailGridRow.fromContactId = data.contactId;
        currentDetailGridRow.fromContactName = data.displayName;
        currentDetailGridRow.fromCompany = data.companyName;

        dataGrid.repaintRows([rowIndex]);
    }

    export function onDetailGridEditingStart(e: any) {
        currentDetailGridRow = e.data;
        detailAccountId = e.component.option("AccountId");
    }

    export function onPopupEditorPreparing(e) {
        if (e.dataField === "changeManagementDescription") {
            e.editorName = "dxTextArea";
        }
    }

    //detail popup support

    export function onDetailEditPopupShowing(e: any) {
        const items = e.component.option("toolbarItems");

        const saveButtonIndex = 0;
        const cancelButtonIndex = 1;
        const saveButton = items[saveButtonIndex];
        const cancelButton = items[cancelButtonIndex];

        const grid: any = $("#SummaryDetailGrid").dxDataGrid("instance");

        cancelButton.options.elementAttr = { class: "cancel" };
        cancelButton.options.icon = "revert";
        cancelButton.options.onClick = (e) => {
            grid.cancelEditData();
            grid.setMode(Areas.GridMode.Normal);
        };

        saveButton.options.type = "success";
        saveButton.options.icon = "save";
        saveButton.options.onClick = (e) => {
            grid.saveEditData();
            grid.setMode(Areas.GridMode.Normal);
        }

        e.component.option("toolbarItems", items);
    }

}
